import * as React from "react";

const SelectDownArrowIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path fill="#00000" d="m20 22.5-5-5h10z"></path>
    </svg>
);

export default SelectDownArrowIconSVG;